import React from "react";


interface SprayFilterProps {
  filter: "NONE" | "RELEASED" | "NOT RELEASED";
  setFilter: (filter: "NONE" | "RELEASED" | "NOT RELEASED") => void;
}

export const SprayListFilter: React.FC<SprayFilterProps> = ({ filter, setFilter }) => {
  return (
    <div className="d-flex justify-content-center align-items-center custom-toggle-switch-wrapper ">
      <div className="custom-toggle-switch">
        <button 
          className={`toggle-option ${filter === "RELEASED" ? 'active' : ''}`}
          onClick={() => setFilter("RELEASED")}
        >
          Traitements validés 
        </button>
        <button 
          className={`toggle-option ${filter !== "RELEASED" ? 'active' : ''}`}
          onClick={() => setFilter("NONE")}
        >
          Programme complet
        </button>
      </div>
    </div>
  );
};
